import { z } from "zod";

export const FilterSidebarFormSchema = z.object({
  isFavoriteOnly: z.boolean().optional().default(false),
  isFeaturedOnly: z.boolean().optional().default(false),
  isSharedWithMeOnly: z.boolean().optional().default(false),
  trades: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional()
    .default([]),
  contentTypes: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        resourceCount: z.number().optional(),
      }),
    )
    .optional()
    .default([]),
  businessRoles: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        description: z.string().nullable(),
      }),
    )
    .optional()
    .default([]),
  categories: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional()
    .default([]),
});

export type FilterSidebarFormData = z.infer<typeof FilterSidebarFormSchema>;
